<div class="flex md:flex-row flex-col gap-6 items-center justify-between mb-6">
  <h2 class="self-start">{{'personalizedJourney.title' | transloco}}</h2>
  <div class="flex flex-col gap-[0.8rem] items-end self-end">
    <progression-bar />
    <app-button
      [text]="'personalizedJourney.clarify.resetResearch' | transloco"
      [variant]="'secondary'"
      [icon]="'back'"
      [iconSize]="'1.5rem'"
      [size]="'sm'"
      (buttonClick)="redirectToJourneyResearch()"
    ></app-button>
  </div>
</div>

<div class="flex flex-col gap-6 mb-20">
  <app-journey-breadcrumb />
  <div class="p-6 bg-white rounded-xl">
    <h2 class="mb-6">
      {{ 'personalizedJourney.hrContactExchange.title' | transloco }}
    </h2>
    @if (loading()) {
    <loader />
    } @else {
    <div class="flex flex-col justify-between items-center gap-6">
      <div
        class="flex flex-1 flex-col bg-vinciLavender md:p-10 px-3 py-6 rounded-xl w-full gap-10"
      >
        @if (isJourneyImmature()) {
        <p>
          {{ 'personalizedJourney.hrContactExchange.subtitle' | transloco }}
        </p>
        }
        <div class="grid grid-cols-1 md:grid-cols-3 gap-[1.5rem]">
          @for (hrContact of hrContactList(); track $index) {
          <app-contact-card
            [spId]="hrContact.spId!"
            [name]="getHrContactFullName(hrContact)"
            [job]="getHrContactJob(hrContact)"
            [entity]="getHrContactEntity(hrContact)"
            [photoUrl]="getPhotoUrl(hrContact)"
            [mail]="getHrContactMail(hrContact)"
            [bookingLink]="getHrContactBookingLink(hrContact)"
            [allowSaving]="false"
          ></app-contact-card>
          }
        </div>

        @if (!isJourneyImmature()) {
        <p class="mobile-hidden text-center flex-1 md:px-20">
          {{ 'personalizedJourney.hrContactExchange.matureTextRow1' | transloco
          }}
        </p>
        <p class="mobile-hidden text-center flex-1 md:px-20">
          {{ 'personalizedJourney.hrContactExchange.matureTextRow2' | transloco
          }}
        </p>
        }
      </div>
    </div>
    }
  </div>
</div>
